module.exports = __webpack_public_path__ + "img/ad_pro.35e3530a.png";